import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { Location } from '@app/_models/_DTOs/location';

@Injectable({ providedIn: 'root' })
export class LocationService extends DataService<Location> {
    constructor(http: HttpClient) {
        super(http, "api/locations")
    }
}